import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { PersonalisedQuoteVehicleInfo } from "../../types/Quote";

export const getQuoteVehicleInfo = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["quote-vehicle-info", quoteId],
    queryFn: (): Promise<PersonalisedQuoteVehicleInfo> => {
      return fetchWithAuth<PersonalisedQuoteVehicleInfo>(
        "getQuoteVehicleInfo",
        quoteId
      );
    },
    enabled: isQueryEnabled(options),
  });
};
